import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/PartScreenStageOne'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class PartScreenStageOneStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "PartScreenStageOneStore",
			variables: false,
		})
	}
}

export async function load_PartScreenStageOne(params) {
  await initClient()

	const store = new PartScreenStageOneStore()

	await store.fetch(params)

	return {
		PartScreenStageOne: store,
	}
}
